import useSWR from 'swr';
import GoogleBusinessService, {
  GoogleBusinessConnectionStatus,
  GoogleBusinessConnectedLocation,
} from '../services/GoogleBusinessService';

const SWR_OPTIONS = {
  revalidateOnFocus: false,
  shouldRetryOnError: false,
} as const;

export function useGoogleBusinessStatus() {
  const { data, error, isLoading, mutate } = useSWR<GoogleBusinessConnectionStatus>(
    '/google-business/status',
    () => GoogleBusinessService.getConnectionStatus(),
    SWR_OPTIONS
  );

  return { status: data ?? null, error, isLoading, mutate };
}

export function useGoogleBusinessConnectedLocations() {
  const { data, error, isLoading, mutate } = useSWR<GoogleBusinessConnectedLocation[]>(
    '/google-business/connected-locations',
    () => GoogleBusinessService.getConnectedLocations(),
    SWR_OPTIONS
  );

  return { locations: data ?? [], error, isLoading, mutate };
}
